var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgElectricBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "#248FFE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L8 12.5L0 11.5L12 0H14L10 7.5L18 8.5L6 20H4ZM9.55 13.825L13.575 9.975L6.85 9.125L8.425 6.2L4.425 10.05L11.125 10.875L9.55 13.825Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricBolt);
export default __webpack_public_path__ + "static/media/electricBolt.5e1e7fc4b10259ff589f901b32b214fa.svg";
export { ForwardRef as ReactComponent };